import React, { Component } from 'react';
import { TweenMax, TimelineMax, CSSPlugin, Expo } from 'gsap/all';
import DrawSVGPlugin from '../gsap-bonus/DrawSVGPlugin';
import ScrollMagic from 'scrollmagic';

import Info from './Info';

import '../styles/components/feature.scss';

import feature from '../assets/feature.png';


export default class Feature extends Component {


    constructor(props) {
      super(props);
      this.ftrigger = null;
      this.fStrokes = [];
      this.feature = null;
      this.highlights = [];
    }

    componentDidMount() {
      TweenMax.set(this.highlights, {
        opacity: 0,
        y: 20
      })

      TweenMax.set(this.fStrokes, {
        drawSVG: 0,
        visibility: 'visible'
      })

      TweenMax.set(this.feature, {
        opacity: 0
      })

      const featureTl = new TimelineMax({paused: true});
      featureTl.to(this.fStrokes, 1.5, {
        drawSVG: '100%',
        ease: Expo.easeInOut
      })
      .to(this.feature, 0.5, {
        opacity: 1
      }, '-=0.125')
      .to(this.fStrokes, 0.5, {
        opacity: 0
      }, '-=0.25')
      .to(this.highlights, 1, {
        opacity: 1,
        y: 0
      })

      const featureController = new ScrollMagic.Controller();
      const featureScene = new ScrollMagic.Scene({
        triggerElement: this.ftrigger,
        triggerHook: "onLeave",
        reverse: true
      }).addTo(featureController);

      featureScene.on("enter", function (event) {
        featureTl.play();
      });
    }

    render() {

        return (
          <div className="feature">
            <span ref={span => this.ftrigger = span} className="fTrigger" />
            <span className="small-title">The vive&trade; vr headset was engineered</span>
            <span className="big-title">Industry Leading Design</span>
            <div className="image-group">
              <img ref={img => this.feature = img} src={ feature } alt='' />
              <svg viewBox="0 0 628.75 511.85">
                <path ref={(fStroke) => { this.fStrokes.push(fStroke) }} d="M575.14,474c-6.08-25.2-3-103-3-103s-31.71,29.1-48.65,41.26c-6.52,31.71-16.51,43.88-22.15,51.26-29.54,45.61-95.57,34.32-105.56,33.88-4.34,14.34-13,26.07-19.11,32.58-22.59,29.54-84.28,20-92.53,19.11-62.12-9.12-157.25-38.66-167.24-43C63.87,487.43,53,456.59,49.1,449.2,29.55,400.55,36.93,314.54,38.24,296.3c7.82-47.35,33.45-56.9,40-59.51,33-1.3,36.49-5.65,44.74-7.39,21.72.44,50.39,2.61,50.39,2.61l50.83-60.38.43-8.25s38.39-40.84,80.88-69.5c5.56-2.18,61.6-46.48,138-51.26,30-.44,56.47,0,56.47,0s58.64,15.64,66.46,41.7c8.69,5.21,73.85,47.35,79.5,87.75,4.77,10,26.49,69.93,8.68,164.19-1.73,7.39-.43,24.76-55.6,16.95-.87,16.5-6.51,86.44.87,119.89" transform="translate(-34.29 -40.92)"/>
                <path ref={(fStroke) => { this.fStrokes.push(fStroke) }} d="M215.55,207.46c-3.82,3-15.57,12.12-20.72,14-.1,4.56,0,9.44,0,9.44l15.1,1.42A117.67,117.67,0,0,1,216.19,208,.42.42,0,0,0,215.55,207.46Z" transform="translate(-34.29 -40.92)"/>
                <path ref={(fStroke) => { this.fStrokes.push(fStroke) }} d="M231.64,197c-2.08,5.07-13.12,32.32-11.94,36.55l10.1,1.09,2.12-37.57A.15.15,0,0,0,231.64,197Z" transform="translate(-34.29 -40.92)"/>
                <path ref={(fStroke) => { this.fStrokes.push(fStroke) }} d="M259.11,240.28l46.28-55.73h4.34s71-86.41,165.09-108.19a2.5,2.5,0,0,1,2.22.56c7.28,6.39,20.68,14.68-.94,31.72-22.59,7.82-68.09,16.51-127.44,73.42-1.56,1.72-23.82,25.26-89.12,58.74A.35.35,0,0,1,259.11,240.28Z" transform="translate(-34.29 -40.92)"/>
                <path ref={(fStroke) => { this.fStrokes.push(fStroke) }} d="M566.6,156.32c-18.79-.51-122.88-1-133.94,51.05,0,5.94-12.49,40,134.92,75a3.89,3.89,0,0,0,3.42-.81l5.48-4.62a3.91,3.91,0,0,0,1.38-2.73c.7-11.27,4.17-77.13-7.46-115A4.1,4.1,0,0,0,566.6,156.32Z" transform="translate(-34.29 -40.92)"/>
                <path ref={(fStroke) => { this.fStrokes.push(fStroke) }} d="M597.4,161.18c4.17,0,20.72.74,31.45,13.39a5.07,5.07,0,0,1,1.15,4c-1.94,13.59-7,43.07-24.68,65.53a.67.67,0,0,1-1.19-.38c-.58-11.09-2.38-69.45-7.32-81.69A.64.64,0,0,1,597.4,161.18Z" transform="translate(-34.29 -40.92)"/>
                <path ref={(fStroke) => { this.fStrokes.push(fStroke) }} d="M256.61,193.29C255,198,250.79,212.84,254,229a.57.57,0,0,0,.54.44h2.1a.53.53,0,0,0,.54-.55c-.06-4-.42-28.69-.13-35.51A.22.22,0,0,0,256.61,193.29Z" transform="translate(-34.29 -40.92)"/>
                <path ref={(fStroke) => { this.fStrokes.push(fStroke) }} d="M238.76,234.34c-.21-7.58-.63-40.28,8-48.36a.78.78,0,0,1,.32-.18,13.77,13.77,0,0,1,3.53-.71.77.77,0,0,1,.81.89c-.89,5.81-5.82,38.5-4.45,46.44a2.56,2.56,0,0,1-1,2.48,9.66,9.66,0,0,1-4.41,1.93A2.53,2.53,0,0,1,238.76,234.34Z" transform="translate(-34.29 -40.92)"/>
              </svg>
              <Info
                myRef={(highlight) => { this.highlights.push(highlight) }}
                name="comfortable"
                extraClass="comfort"
                message="The most comfortable VR headsets ever made. VIVE strives for optimum comfort."
              />
              <Info
                myRef={(highlight) => { this.highlights.push(highlight) }}
                secondName="adjustable hinge"
                extraClass="adjust"
                message="The new VIVE comes with an adjustable hinge to fit all shapes and sizes no matter what."
              />
              <Info
                myRef={(highlight) => { this.highlights.push(highlight) }}
                name="balanced design"
                extraClass="balance"
                message="With a balanced design, the portability and durability of the new VIVE reaches new heights."
              />
            </div>
          </div>
        );
    }
}
